import { GameConstants } from "../GameConstants";

import { GameVars } from "../GameVars";

import { AudioManager } from "../AudioManager";

import { PuzzlePage } from "./PuzzlePage";

export class PuzzleButtonPagesContainer extends Phaser.Group {

    public scrolling: boolean;

    private currentPage: number;
    private totalPages: number;
    private puzzlePagesContainer: Phaser.Group;
    private paginationCirclesContainer: Phaser.Group;
    private down_t: number;
    private down_px: number;
    
    constructor(game: Phaser.Game) {

        super(game, null, "puzzle-button-pages-container");

        this.down_t = 0;
        this.down_px = 0;
        this.scrolling = false;

        this.createPages();

        this.setCurrentPage();
        this.setPagesVisibility();

        // LOS CIRCULOS DE DEBAJO
        this.paginationCirclesContainer = new Phaser.Group(this.game);
        this.paginationCirclesContainer.y = GameConstants.GAME_HEIGHT - 90 * GameVars.scaleY;
        this.paginationCirclesContainer.scale.y = GameVars.scaleY;
        this.add(this.paginationCirclesContainer);

        for (let i = 0; i < this.totalPages; i ++) {

            const px = GameConstants.GAME_WIDTH / 2 + 25 * ( i - (this.totalPages - 1) / 2);

            const circle = new Phaser.Graphics(this.game);
            circle.beginFill(0xFFFFFF);
            circle.drawCircle(px, 0, 15);
            circle.inputEnabled = true;
            circle.events.onInputDown.add(this.onCircleDown, this, null, i)
            this.paginationCirclesContainer.add(circle);

            if (i !== this.currentPage - 1) {
                circle.alpha = .5;
            }
        }

        this.game.input.onDown.add(this.onDown, this);
        this.game.input.onUp.add(this.onUp, this);
    }

    private onCircleDown(circle: Phaser.Graphics, pointer:Phaser.Pointer, index: number): void {

        if (GameVars.showLevelCompleted) {
            return;
        }

        if (this.scrolling) {
            return;
        }

        AudioManager.playSound("click"); 

        this.currentPage = index + 1;

        this.allPagesVisible();

        this.scrolling = true;

        this.game.add.tween(this.puzzlePagesContainer)
            .to({x: -(GameConstants.GAME_WIDTH * (this.currentPage - 1))}, 300, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function(): void {
                this.scrolling = false;
                this.setPagesVisibility();
            }, this);

        for (let i = 0; i < this.paginationCirclesContainer.length; i ++) {

            const circle = <Phaser.Graphics> this.paginationCirclesContainer.getChildAt(i);
            circle.alpha = i === this.currentPage - 1 ? 1 : .5;
        }
    }

    private createPages(): void {

        this.puzzlePagesContainer = new Phaser.Group(this.game);
        this.add(this.puzzlePagesContainer);

        // TODO: DE MANERA TEMPORAL
        let totalProblems: number;

        if (GameVars.puzzleMoves === 2) {
            totalProblems = 219;
        } else if (GameVars.puzzleMoves === 3) {
            totalProblems = 483;
        } else {
            totalProblems = 459;
        }

        let rows: number;
        const aspectRatio = this.game.scale.aspectRatio;

        if (aspectRatio > .65) {
            rows = 5;
        } else if (aspectRatio > .58) {
            rows = 6;
        } else if (aspectRatio > .5) {
            rows = 7;
        } else {
            rows = 8;
        }

        this.totalPages = Math.floor(totalProblems / (rows * 4));

        if (totalProblems % (rows * 4) > 0) {
            this.totalPages ++;
        }

        let index = 1;

        for (let i = 0; i < this.totalPages; i++) {

            const puzzlePage = new PuzzlePage(this.game, index, rows, totalProblems);
            puzzlePage.x = i * GameConstants.GAME_WIDTH;
            this.puzzlePagesContainer.add(puzzlePage);

            index += 4 * rows;
        }
    }

    private onDown(p: Phaser.Pointer): void {

        if (GameVars.showLevelCompleted) {
            return;
        }

        this.down_px = p.x;
        this.down_t = this.game.time.time;
    }

    private onUp(p: Phaser.Pointer): void {

        if (GameVars.showLevelCompleted) {
            return;
        }

        if (this.scrolling) {
            return;
        }

        // utilizando p.positionDown.x y p.timeDown no funcionaba
        const swipe = p.x - this.down_px;

        if (Math.abs(swipe) > 100 && this.game.time.time - this.down_t < 500) {

            if (swipe > 0 && this.currentPage !== 1) {
                
                this.scrolling = true;

                this.game.add.tween(this.puzzlePagesContainer)
                    .to({x: this.puzzlePagesContainer.x + GameConstants.GAME_WIDTH}, 300, Phaser.Easing.Cubic.Out, true)
                    .onComplete.add(function(): void {
                        this.scrolling = false;
                        this.setPagesVisibility();
                    }, this);
                
                this.currentPage --;
            }

            if (swipe < 0 && this.currentPage !== this.totalPages) {
                
                this.scrolling = true;

                this.game.add.tween(this.puzzlePagesContainer)
                    .to({x: this.puzzlePagesContainer.x - GameConstants.GAME_WIDTH}, 300, Phaser.Easing.Cubic.Out, true)
                    .onComplete.add(function(): void {
                        this.scrolling = false;
                        this.setPagesVisibility();
                    }, this);

                this.currentPage ++;
            }

            // cambiamos la visibilidad de la siguiente pagina
            const nextPage = <Phaser.Group> this.puzzlePagesContainer.getAt(this.currentPage - 1);
            nextPage.visible = true;
        }

        for (let i = 0; i < this.paginationCirclesContainer.length; i ++) {

            const circle = <Phaser.Graphics> this.paginationCirclesContainer.getChildAt(i);
            circle.alpha = i === this.currentPage - 1 ? 1 : .5;
        }
    }

    private setCurrentPage(): void {

        for (let i = 0; i < this.puzzlePagesContainer.length; i++) {
            let page: any = this.puzzlePagesContainer.getAt(i);
            if (page.lastProblem()) {
                this.currentPage = i + 1;
            }
        }

        this.puzzlePagesContainer.x = -(GameConstants.GAME_WIDTH * (this.currentPage - 1));
    }

    private allPagesVisible(): void {

        for (let i = 0; i < this.puzzlePagesContainer.length; i ++) {
            
            const page = <Phaser.Group> this.puzzlePagesContainer.getAt(i);
            page.visible = true;
        }
    }

    private setPagesVisibility(): void {

        for (let i = 0; i < this.puzzlePagesContainer.length; i ++) {
            
            const page = <Phaser.Group> this.puzzlePagesContainer.getAt(i);

            if (i === this.currentPage - 1) {
                page.visible = true;
            } else {
                page.visible = false;
            }
        }
    }
}
